<template>
  <div>
    <!--<serve-items></serve-items>-->
    <div class="server-mask" v-if="showServerItems"></div>
    <button class="server-close-btn" v-if="showServerItems" @click="closeServer"></button>
    <div class="server-items-warpper" v-if="showServerItems">
      <server-item></server-item>
    </div>

    <div class="page-bg">
      <img class="user-avatar" src="../../assets/logo-icon.png" />
      <div class="page-outbox">
        <form name="registerForm" class="register-form inputcontent" action=javascript:void(0);>
          <div class="input-group required">
            <label>电子邮箱</label>
            <input class="form-input username" v-model="registerData.cus_email" type="text" placeholder="" />
          </div>
          <div class="input-group required">
            <label>设置密码</label>
            <input class="form-input username" v-model="registerData.cus_password" type="password" placeholder="" />
          </div>
          <div class="input-group required">
            <label>确认密码</label>
            <input class="form-input username" v-model="registerData.cus_re_password" type="password" placeholder="" />
          </div>
          <div class="input-group required">
            <label>姓名</label>
            <input class="form-input username" v-model="registerData.cus_name" type="text" placeholder="" />
          </div>
          <div class="input-group required">
            <label>手机</label>
            <input class="form-input username" v-model="registerData.cus_mobile" type="text" placeholder="" />
          </div>
          <div class="input-group">
            <label>座机</label>
            <input class="form-input username" v-model="registerData.cus_phone" type="text" placeholder="" />
          </div>
          <div class="input-group">
            <label>传真</label>
            <input class="form-input username" v-model="registerData.cus_fax" type="text" placeholder="" />
          </div>
          <div class="input-group required">
            <label>所属地区</label>
            <p class="area-group">
              <input class="form-input username" v-model="registerData.ca_province" type="text" placeholder=""
                     @click="showAddr('province')"/>
              <input class="form-input username" v-model="registerData.ca_city" type="text" placeholder=""
                     @click="showAddr('city',registerData.ca_province)" />
              <input class="form-input username" v-model="registerData.ca_county" type="text" placeholder=""
                     @click="showAddr('county',registerData.ca_city)" />
            </p>
          </div>
          <div class="input-group required">
            <label>街道地址</label>
            <input class="form-input username" v-model="registerData.ca_street" type="text" placeholder="" />
          </div>
          <div class="input-group required">
            <label>开票类型</label>
            <div class="invoice-type">
              <p class="invoice-type-item" @click="setInvoiceType('1')"><i class="mint-checkbox-core" :class="{'checked':registerData.ci_type=='1'}"></i>普通发票</p>
              <p class="invoice-type-item" @click="setInvoiceType('2')"><i class="mint-checkbox-core" :class="{'checked':registerData.ci_type=='2'}"></i>专用发票 </p>
            </div>
          </div>
          <div class="input-group required">
            <label>开票抬头</label>
            <input class="form-input username" v-model="registerData.ci_title" type="text" placeholder="" />
          </div>
          <div class="input-group required">
            <label>税号</label>
            <input class="form-input username" v-model="registerData.ci_vatno" type="text" placeholder="" />
          </div>
          <template v-if="registerData.ci_type=='2'">
            <div class="input-group required">
              <label>开户行</label>
              <input class="form-input username" v-model="registerData.ci_bank" type="text" placeholder="" />
            </div>
            <div class="input-group required">
              <label>银行账号</label>
              <input class="form-input username" v-model="registerData.ci_bknum" type="text" placeholder="" />
            </div>
            <div class="input-group required">
              <label>开票地址</label>
              <input class="form-input username" v-model="registerData.ci_addr" type="text" placeholder="" />
            </div>
            <div class="input-group required">
              <label>开票电话</label>
              <input class="form-input username" v-model="registerData.ci_phone" type="text" placeholder="" />
            </div>
          </template>

          <p class="form-link">
            <label @click="agreeServer" :class="{'active':isAgree}">同意本应用<a href="javascript:void(0)" @click="toServer">《服务条款》</a></label>
          </p>
        </form>
      </div>
      <button class="form-btn" @click="registerSub">注&nbsp;&nbsp;册</button>
      <addr-selector ref="addrSelector" :curProvince="registerData.ca_province" :curCity="registerData.ca_city"
                     :curCounty="registerData.ca_county" @endSelectAddr="endSelectAddr"></addr-selector>
    </div>
  </div>


</template>

<script>
  import AddrSelector from 'basic/addrSelector/addrSelector'
  import ServerItem from './serverItem'
	export default {
    name: 'register',
    data () {
      return {
      	registerData:{
      		cus_email:'',
      		cus_password:'',
      		cus_re_password:'',
      		cus_name:'',
      		cus_mobile:'',
      		cus_phone:'',
      		cus_fax:'',
      		ca_province:'',
      		ca_city:'',
      		ca_county:'',
      		ca_street:'',
      		ci_type:1,
      		ci_title:'',
      		ci_vatno:'',
      		ci_bank:'',
      		ci_bknum:'',
      		ci_addr:'',
      		ci_phone:''
      	},
      	username:'',
      	checkcode:'',
      	isAgree:false,
        showServerItems:false,
        checkRules:[
          {
            key:'cus_email',
            name:'输入电子邮箱地址',
            formType:'email',
            required:true,
            message:'电子邮箱地址格式不正确，且不要有空格符'
          },
          {
            key:'cus_password',
            name:'输入密码',
            required:true,
            formType:'equal',
            eqItem:'cus_re_password',
            message:'两次密码输入不一致'
          },
          {
            key:'cus_re_password',
            name:'重新输入密码',
            required:true,
            formType:'equal',
            eqItem:'cus_password',
            message:'两次密码输入不一致'
          },
          {
            key:'cus_name',
            name:'输入姓名',
            required:true
          },
          {
            key:'cus_mobile',
            name:'输入手机号码',
            required:true,
            formType:'mobile',
            message:'请输入正确的手机号'
          },
          {
            key:'ca_province,ca_city,ca_county',
            name:'选择城市',
            required:true
          },
          {
            key:'ca_street',
            name:'输入街道地址',
            required:true
          },
          {
            key:'ci_title',
            name:'输入开票抬头',
            required:true
          },
          {
            key:'ci_vatno',
            name:'输入税号',
            required:true
          },
          {
            key:'ci_bank',
            name:'输入开户行',
            required:true
          },
          {
            key:'ci_bknum',
            name:'输入银行账号',
            required:true
          },
          {
            key:'ci_addr',
            name:'输入开票地址',
            required:true
          },
          {
            key:'ci_phone',
            name:'输入开票电话',
            required:true
          }
        ]
      }
    },
    mounted(){
      //获取焦点时移到页面可见区域
      $('.inputcontent textarea,.inputcontent input').unbind('focus').bind('focus',function(e){
        var dom=e.target;
        setTimeout(function(){
          dom.scrollIntoView(true); dom.scrollIntoViewIfNeeded();
        }, 200);
      })
    },
    methods:{
      showAddr(type,parent){
        this.$refs.addrSelector.showAddr(type,parent);
      },
      endSelectAddr(vals){
        console.log(vals);
        this.registerData.ca_province=vals[0];
        this.registerData.ca_city=vals[1];
        this.registerData.ca_county=vals[2];
      },
      setInvoiceType(type){
        if(this.invoiceType!=type){
          this.registerData.ci_type=type;
          this.$nextTick(function(){
            //获取焦点时移到页面可见区域
            $('.inputcontent textarea,.inputcontent input').unbind('focus').bind('focus',function(e){
              var dom=e.target;
              setTimeout(function(){
                dom.scrollIntoView(true); dom.scrollIntoViewIfNeeded();
              }, 200);
            })
          })
        }
      },
    	registerSub(){
        if(this.checkData()){
          if(!this.isAgree){
            this.$toast('请勾选同意本应用《服务条款》');
            return;
          }
          var _sendData=JSON.parse(JSON.stringify(this.registerData));
          delete _sendData.cus_re_password;
          if(this.registerData.type==1){
            delete _sendData.ci_bank;
            delete _sendData.ci_bknum;
            delete _sendData.ci_addr;
            delete _sendData.ci_phone;
          }
          this.$cHttp.post('customers/sign',{
            partner:this.$systemConfig.partner,
            apikey:this.$systemConfig.apikey,
            ...this.registerData
          }).then((res)=>{
            console.log(res)
            if(res.status==1){
              this.$toast('注册成功！');
              this.$router.replace('/login');
            }else{
              this.$toast(res.error_msg);

            }
          }).catch((msg)=>{
            this.$toast(msg)
          })
        }
    	},
    	agreeServer(){
    		this.isAgree=!this.isAgree;
    	},
    	toServer(){
        this.showServerItems=true;
    	},
      closeServer(){
        this.showServerItems=false;
      },
      checkData(){
        //表单验证
        var checkLength=0;
        if(this.registerData.ci_type==1){
          checkLength=9;
        }else{
          checkLength=13;
        }
        for(var i=0;i<checkLength;i++){
          var keyArr=this.checkRules[i].key.split(',');
          for(var j=0;j<keyArr.length;j++){
            //非空检验
            if(this.checkRules[i].required&&!this.registerData[keyArr[j]]){
              this.$toast('请'+this.checkRules[i].name);
              return false;
            }else{
              //格式检验
              if(this.checkRules[i].formType){
                var _value=this.registerData[keyArr[j]];
                switch(this.checkRules[i].formType){
                  case 'mobile':
                    if(!/^1[34578]\d{9}$/.test(_value)){
                      this.$toast(this.checkRules[i].message);
                      return false;
                    }
                    break;
                  case 'email':
                    if(!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(_value)){
                      this.$toast(this.checkRules[i].message);
                      return false;
                    }
                    break;
                  case 'equal':
                    var _eqValue=this.registerData[this.checkRules[i].eqItem];
                    if(!_eqValue||_eqValue!==_value){
                      this.$toast(this.checkRules[i].message);
                      return false;
                    }
                    break;
                }
              }
            }
          }
        }
        return true;
      }
    },
    components:{
      AddrSelector,ServerItem
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
  .server-items-warpper{
    position: absolute;
    z-index: 1001;
    left:.1rem;
    right:.1rem;
    top:.2rem;
    bottom:.4rem;
    overflow: auto;
    background-color:#fff;
    border-radius: .08rem;
  }
  .server-mask{
    background-color: rgba(0,0,0,.5);
    position: fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index: 1001;
  }
  .server-close-btn{
    position: fixed;
    bottom:.1rem;
    right:50%;
    margin-right: -.125rem;
    width: .25rem;
    height:.25rem;
    border:2px solid $mainColor;
    border-radius: .2rem;
    background:url(../../assets/close-icon.png) no-repeat center;
    background-size: .1rem .1rem;
    background-color: #fff;
    z-index: 100000;
  }
  .invoice-type{
    padding: 0.05rem 0;
    display: flex;
    width: 100%;
    margin-bottom: .1rem;
    text-align:center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.4);
    .invoice-type-item{
      flex: 1;
    }
  }
  .set-default-group,.invoice-type-item{
    padding-left: .05rem;
    font-size: .14rem;
    .mint-checkbox-core{
      margin-right: .1rem;
      width:16px;
      height:16px;
      background-color: transparent;
      border-color: #fff;
      &:after{
        top:1px;
      }
      &.checked{
        background-color: $mainColor;
        border-color: $mainColor;
        &:after{
          border-color: #fff;
          transform: rotate(45deg) scale(1);
        }
      }
    }

  }
  .page-bg{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    font-size: .16rem;
    text-align: center;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    background:url(../../assets/login-bg.jpg) no-repeat center;
    background-size:cover;
    background-color: #e16c6d;
    z-index: 1000;
    .user-avatar{
      display: block;
      margin: .2rem auto;
      width: .5rem;
      height:.5rem;
      border:.04rem solid #fff;
      border-radius: .8rem;
      background-color:#fff;
    }
  }
.page-outbox{
  min-width: 3rem;
  width: 90%;
  margin: 0 auto;
  position: static;
  bottom: .6rem;
  overflow: auto;
	display: flex;
	align-items: center;
	bottom:0;
}
.register-form{
  padding: .1rem;
	color:#fff;
  border-radius: .06rem;
  border:1px solid rgba(255,255,255,.2);
  background-color:rgba(255,255,255,.1);
  .input-group{
    display: flex;
    &.required{
      >label:after{
        content:" *";
        color:$warningLightColor;
      }
    }
    >label{
      min-width: .79rem;
      text-align: right;
      padding-top: 0.08rem;
    }
    .form-input{
      margin-bottom: .1rem;
      width: 100%;
      line-height: .3rem;
      font-size: .16rem;
      color: #fff;
      text-indent: .08rem;
      border:none;
      border-bottom: 1px solid rgba(255,255,255,.4);
      background-color: transparent;
      /*background-color: rgba(255,255,255,.1);*/
      background-repeat:no-repeat;
      background-size: .2rem .2rem;
      background-position: .08rem center;
      &.checkcode{
        padding-right: .77rem;
        box-sizing: border-box;
      }
    }
  }

	.checkcode-block{
		position:relative;
		.get-checkcode-btn{
			position:absolute;
			top:.05rem;
			right:0;
			padding:0 .05rem;
			font:inherit;
			line-height: .22rem;
			font-size:.12rem;
			color: #666;
			border: $mainColor-light4;
			border-radius: .2rem;
			background-color:#fff;
			&:active{
				opacity: .7;
			}
		}
	}
	.form-link{
		margin-bottom:.1rem;
		display: flex;
		font-size: .14rem;
		color: #fff;
		a{
			font-size: .12rem;
			color: #fff;
			text-decoration: underline;
		}
		label:before{
			content:"";
			display: inline-block;
			vertical-align: middle;
			margin-right:.04rem;
			width:.12rem;
			height:.12rem;
			border:1px solid #fff;
			border-radius: .02rem;
		}
		label.active:before{
			background:url(../../assets/selected-list.png) no-repeat center;
			background-size: .1rem .1rem;
			background-color: #fff;
		}
	}
}
  .form-btn{
    display: block;
    margin: .2rem auto;
    width: 3rem;
    line-height: .35rem;
    font-size: .16rem;
    color: $mainColor;
    border:none;
    background-color: #fff;
    border-radius: .06rem;
    &:active{
      opacity: .7;
    }
  }

::-webkit-input-placeholder{
	color:rgba(255,255,255,.7);
}
:-moz-input-placeholder{
	color:rgba(255,255,255,.7);
}
::-moz-input-placeholder{
	color:rgba(255,255,255,.7);
}
:-ms-input-placeholder{
	color:rgba(255,255,255,.7);
}
</style>



// WEBPACK FOOTER //
// src/components/login/register.vue